export const DRAWER_WIDTH = 260

export const DRAWER_KEYS = {
    DASHBOARD: 'DASHBOARD',
    CREDIT_POLICIES: 'CREDIT_POLICIES',
    CREDIT_POLICIES_LIST: 'CREDIT_POLICIES_LIST',
    CREDIT_POLICIES_CREATE: 'CREDIT_POLICIES_CREATE',
    BYPASS_LIST: 'BYPASS_LIST',
    CUSTOMERS: 'CUSTOMERS',
    SCORE: 'SCORE',
    BATCH_FILE: 'BATCH_FILE',
    EXIT: 'EXIT'
}
